











import {Component, Mixins} from 'vue-property-decorator'
import RankingColumn from "@/components/account/rewardPoints/RankingColumn.vue";
import api from "@/api/api";
import ConvertTimezone from "@/helpers/mixins/ConvertTimezone";

@Component({
  components: {
    RankingColumn
  }
})
export default class PointRanking extends Mixins(ConvertTimezone) {
  public updateTime = ""
  public totalList: object[] = []
  public monthlyList: object[] = []
  public wishList: object[] = []

  created(){
    this.getTotalList()
    this.getMonthlyList()
  }

  async getTotalList(){
    try{
      const res = await api.getTotalRanking(10, 1)
      this.totalList = res.data.dataList||[]
      this.updateTime = new Date().toISOString()
    }catch (e){
      console.log(e)
    }
  }
  async getMonthlyList(){
    try{
      const res = await api.getMonthlyRanking(10, 1)
      this.monthlyList = res.data.dataList||[]
    }catch (e){
      console.log(e)
    }
  }

}
